import { render, staticRenderFns } from "./StatementAdjustment.vue?vue&type=template&id=a72541c8"
import script from "./StatementAdjustment.vue?vue&type=script&lang=js"
export * from "./StatementAdjustment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports